import { render, staticRenderFns } from "./WidgetTrendLineGraph.vue?vue&type=template&id=e08a1efe&scoped=true&"
import script from "./WidgetTrendLineGraph.vue?vue&type=script&lang=js&"
export * from "./WidgetTrendLineGraph.vue?vue&type=script&lang=js&"
import style0 from "./WidgetTrendLineGraph.vue?vue&type=style&index=0&id=e08a1efe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08a1efe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e08a1efe')) {
      api.createRecord('e08a1efe', component.options)
    } else {
      api.reload('e08a1efe', component.options)
    }
    module.hot.accept("./WidgetTrendLineGraph.vue?vue&type=template&id=e08a1efe&scoped=true&", function () {
      api.rerender('e08a1efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/widgets/WidgetTrendLineGraph.vue"
export default component.exports